// extracted by mini-css-extract-plugin
module.exports = {"ContainerText":"description_ContainerText__3oPuI","CarrouselTitle":"description_CarrouselTitle__3JVfu","CarrouselDescription":"description_CarrouselDescription__3ebZV"};